import { render } from "./WishlistButtonV3.vue?vue&type=template&id=5ee62e58&scoped=true"
import script from "./WishlistButtonV3.vue?vue&type=script&lang=js"
export * from "./WishlistButtonV3.vue?vue&type=script&lang=js"

import "./WishlistButtonV3.vue?vue&type=style&index=0&id=5ee62e58&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/rb-redev/rb-redev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ee62e58"]])

export default __exports__